import { useNavigate } from 'react-router-dom'
import Button from '@/components/ui/Button'

export default function NotFoundPage() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/', { replace: true })
  }

  return (
    <div className="min-h-screen bg-tg-bg flex flex-col items-center justify-center p-6 text-center">
      <div className="text-6xl mb-4">🤷</div>
      <h1 className="text-2xl font-bold text-tg-text mb-2">
        Страница не найдена
      </h1>
      <p className="text-tg-hint mb-6">
        Такой страницы не существует
      </p>
      <Button onClick={handleGoHome}>На главную</Button>
    </div>
  )
}
